import React from "react";
import { useDownloadFinancialDocumentFile } from "@components/documents/FinancialDocumentDetails/useDownloadFinancialDocumentFile";
import { AttachedFinancialDocumentRow } from "@components/documents/AttachedFinancialDocumentRow/AttachedFinancialDocumentRow";
import { FinancialDocument } from "@common/types/financialDocument";

interface Props {
    financialDocument: FinancialDocument;
    detachDocument: (documentId: number) => void;
}

export const JournalEntryDocument: React.FC<Props> = ({
    financialDocument,
    detachDocument,
}) => {
    const { download } = useDownloadFinancialDocumentFile(financialDocument);

    return (
        <AttachedFinancialDocumentRow
            financialDocument={financialDocument}
            detachDocument={detachDocument}
            onViewDocument={download}
            detachAriaLabel="Detach from journal entry"
            detachTooltip="Detach from this journal entry"
            testId="transaction-document"
            deleteAction="detachThenDelete"
        />
    );
};
